<template>
  <div class="mainWrapper">
    <div class="inner" ref="inner">
      <template v-for="(list, index) in latestNews" :key="index">
        <component
          :is="
            list.length !== pageSize
              ? 'universalList'
              : `bar${index.toString().substr(-1)}`
          "
          :list="list"
          transition-mode="out-in"
        />
      </template>
    </div>
    <div
      v-if="show.spinner"
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 44px 0;
      "
      :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
    >
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, watch } from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/medicine/MainBar";
import FirstBar from "@/components/medicine/FirstBar";
import SecondBar from "@/components/medicine/SecondBar";
import ThirdBar from "@/components/medicine/ThirdBar";
import FourthBar from "@/components/medicine/FourthBar";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useStore } from "vuex";
import { useLanguage } from "@/utils/language";

export default {
  components: {
    universalList: AdditionalBar,
    bar0: MainBar,
    bar1: FirstBar,
    bar2: SecondBar,
    bar3: ThirdBar,
    bar4: FourthBar,
    bar5: MainBar,
    bar6: FirstBar,
    bar7: SecondBar,
    bar8: ThirdBar,
    bar9: FourthBar,
  },
  setup() {
    const store = useStore();
    const pageSize = 5; // Number of elements per Bar
    const {i18n} = useLanguage();

    const inner = ref(null);
    const show = reactive({
      spinner: true,
    });
    const scrollEnd = () => {
      // How handle the end of news feed
      show.spinner = false;
    };

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'medicine',
          load,
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd,
    });

    const refreshData = () => {
      // Necessary to empty the news feed when
      // routing through pages
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    // It is not essential to re-run this function
    // but you can if you need to.
    // All it does is just <<restarts>> your page
    refreshData();

    watch(() => i18n.global.locale.value, refreshData);

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews),
    };
  },
};
</script>


<style lang="scss" scoped>
.mainWrapper {
  /* FONT COLOR */
  --primary-m-color: rgba(37, 119, 116, 1);
  --primary-t-color: rgba(37, 119, 116, 0.7);
  --primary-b-color: rgba(37, 119, 116, 0.8);
  --primary-carousel-b: rgba(37, 119, 116, 0.6);
  --light-t-color: rgba(255, 255, 255, 0.7);
  --light-m-color: rgba(255, 255, 255, 1);
  --light-b-color: rgba(255, 255, 255, 0.7);
  --light-p-color: rgba(255, 255, 255, 0.9);
  --black-color: rgba(18, 18, 18, 1);
  --grey-t-color: rgba(18, 18, 18, 0.7);
  --grey-b-color: rgba(18, 18, 18, 0.8);
  /* BACKGROUND COLOR */
  --mainBar-bg: linear-gradient(180deg, #136a8a 0%, #267871 100%);
  --left-b-bg: rgba(253, 255, 255, 0.25);
  --right-b-bg: rgba(253, 255, 255, 1);
  --light: #ffffff;

  width: 100%;
  position: relative;

  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: var(--mainBar-bg);
  }
}
</style>
